/* eslint-disable react/prop-types */
import React from "react";
import AppUserProfile, { UserType } from "../assets/js/AppUserProfile";

const AdjustAmountForm = ({
  onChangeClaimAmount,
  isError,
  proposalAmount,
  adjustAmount,
  isAdjustAble,
  isDense = false,
}) => {
  const userRole = AppUserProfile.getData()["whoami"];

  const handleClaimAmountChange = (e) => {
    let value = parseFloat(e.target.value);
    if (isNaN(value)) {
      value = 0;
    } else if (value < 0) {
      value = 0;
      e.target.value = 0;
    }

    onChangeClaimAmount?.(value);
  };

  const cellPadding = isDense ? "px-1 py-2" : "p-2";
  const textSize = isDense ? "text-xs" : "text-sm";

  return (
    <div
      className={`${
        isDense ? "w-fit" : "w-full max-w-4xl"
      }  mx-auto ${textSize} flex flex-col`}
    >
      <div
        className={`border ${
          isError ? "border-red-500" : "border-black"
        } rounded-lg overflow-hidden`}
      >
        <div className="grid grid-cols-3">
          <div
            className={`${cellPadding} bg-[#F0F0F0] border-r-[0.5px] border-dark-gray min-w-[50px]`}
          ></div>

          <div
            className={`${cellPadding} bg-[#F0F0F0] border-r-[0.5px] border-dark-gray `}
          >
            <span>จำนวนเงินที่ขอ</span>
          </div>

          <div className={`${cellPadding} bg-[#F0F0F0] `}>
            <span className={isError ? "text-red-500" : "text-black"}>
              {userRole == UserType.DEALER_BYD ||
              userRole == UserType.DEALER_DENZA
                ? isAdjustAble
                  ? "จำนวนเงินที่ใช้ไป"
                  : "จำนวนเงินอนุมัติเบื้องต้น"
                : "จำนวนเงินอนุมัติเบื้องต้น"}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-3 border-t-[0.5px] border-[#DBDBDB]">
          <div
            className={`bg-white border-r-[0.5px] border-dark-gray flex items-center justify-end ${cellPadding} `}
          >
            <span>จำนวนเงินก่อน VAT</span>
          </div>

          <div
            className={`bg-white border-r-[0.5px] border-dark-gray flex items-center ${cellPadding} `}
          >
            <span className="font-medium break-all w-full">
              {Number(proposalAmount).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 5,
              })}
            </span>
          </div>

          <div className={`${cellPadding} bg-white  flex items-center`}>
            {isAdjustAble ? (
              <input
                type="number"
                onChange={handleClaimAmountChange}
                className={`w-full p-1 border ${
                  isError ? "border-red-500" : "border-gray-300"
                } rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
            ) : (
              <span className="font-medium break-all w-full">
                {Number(adjustAmount).toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 5,
                })}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="pt-2 text-red-500">{isError}</div>
    </div>
  );
};

export default AdjustAmountForm;
